import { useState } from 'react';
import { supabase } from '../supabase';

export interface UseCreateProject {
  creating: boolean;
  error: string | null;
  /** Inserts a project for the org; returns the new id, or null on failure (error set). */
  create: (orgId: string, name: string, description: string) => Promise<string | null>;
}

export function useCreateProject(): UseCreateProject {
  const [creating, setCreating] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const create = async (orgId: string, name: string, description: string): Promise<string | null> => {
    setCreating(true);
    setError(null);
    try {
      const { data, error: insErr } = await supabase
        .from('projects')
        .insert({ org_id: orgId, name: name.trim(), description: description.trim() })
        .select('id')
        .single();
      if (insErr || !data) {
        setError(insErr?.message ?? 'Could not create project');
        return null;
      }
      return data.id as string;
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Unexpected error creating project');
      return null;
    } finally {
      setCreating(false);
    }
  };

  return { creating, error, create };
}
